import React from "react";

const Payouts = () => {
	return (
		<div className="pageWrapper">
			<div className="pageTop">
				<h2>Payouts</h2>
			</div>

			<div className="innerContent">
				<p>The content for payouts page goes here...</p>
			</div>
		</div>
	);
};

export default Payouts;
